import { useState } from 'react';
import {
  IconStyle,
  TextLink,
  TextLinkIconPosition,
  TextLinkStyle,
  useTranslation,
  Theme,
  AlertMessage,
} from '@nextgen-web-framework/all';
import styles from './InstalmentDetails.module.scss';
import { InstalmentDetailsDrawer } from './components/instalment-details-drawer/InstalmentDetailsDrawer';
import instalmentDetailsProps from './types/propTypes';

export const InstalmentDetails = ({ productId, isAlertLink }: instalmentDetailsProps) => {
  const t = useTranslation();
  const [showDrawer, setShowDrawer] = useState(false);
  const onCloseDrawer = () => {
    setShowDrawer(false);
  };
  return (
    <div className={`${styles['instalment-details-wrapper']}`} data-testid="instalment-wrapper">
      {isAlertLink ? (
        <AlertMessage
          className={styles['instalment-plan-link']}
          content={{
            heading: t('payment.instalmentDetails.instalmentOptionsCta'),
          }}
          hasIcon
          onClick={() => setShowDrawer(true)}
          theme={Theme.BLUE}
          icon="calendar-check"
        />
      ) : (
        <TextLink
          theme={Theme.BLUE}
          leftIcon={{
            iconName: 'calendar-check',
            iconStyle: IconStyle.SOLID,
          }}
          iconPosition={TextLinkIconPosition.LEFT}
          id="open-drawer-testid"
          text={t('payment.instalmentDetails.cta.label')}
          textLinkStyle={TextLinkStyle.ICONUNDERLINE}
          onClick={() => setShowDrawer(true)}
          scroll={false}
          data-testid="open-drawer-testid"
        />
      )}

      {showDrawer && <InstalmentDetailsDrawer onCloseDrawer={onCloseDrawer} productId={productId} pIPP={true} />}
    </div>
  );
};
